export default "__VITE_ASSET__BGaGD5iK__"